import {ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-shared-status',
    templateUrl: './shared-status.component.html',
    styleUrls: ['./shared-status.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedStatusComponent implements OnInit {
  @Input() code: string;
  statusList = {
    VAL: 'Validé',
    RED: 'En cours de rédaction',
    APP: 'En attente d\'approbation',
    REF: 'Refusé',
  };

  constructor() {
  }

  get classes() {
    return {
      '-is-refused': this.code === 'REF',
      '-is-validated': this.code === 'VAL',
      '-on-redaction': this.code === 'RED',
      '-to-approve': this.code === 'APP',
    };
  }

  ngOnInit() {
  }

}
